import { useState, useEffect } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";


function Reader(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,reader', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const searchReader = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,reader_search', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                         var finded = parseInt(res.result);

                         if(finded == 0)
                         {
                            props.mainView.showDialog( "O nie!","Nie znaleziono żadnego nowego urządzenia. Upewnij się, że korzytasz z tej samiej sieci LAN. " , "ok" , null);  
                         }else
                         {
                            props.mainView.showDialog( "Sukces!","Znaleziono urządzeń:  " + finded , "ok" , null);  
                         }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    if(tab == null)
    {
        setTab([]);
        getData(); 
        return (
            <div></div>
        );        
    }


    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }



    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        getData();
    }
 

    return (
        <div className="view_content">
            


          

            <div className="bg_center">   

            <div className="table_widget">
                 <span className="btn" onClick={searchReader}>Znajdź urządzenie w sieci</span>
            </div>

                
                <table className="table">
                            <thead>
                                <tr className="header">
                                    <td className="td_left">LP</td>                           
                                    <td>Numer instalacji / urządzenia</td>  
                                    <td>Opis</td>
                                    <td>Typ</td>                          
                                    <td className="td_right">Ostatnia aktywność</td>  
                                </tr>
                            </thead>
                            <tbody>
                            

                                {
                                    tab.result.map(  (item, ix) => {
 
                                    return (
                                            <tr className="row">
                                                <td className="gocenter">{ (ix + 1) }</td>                                                                     
                                                <td className="gocenter">{ item.reader_card_id }</td> 
                                                <td className="gocenter">{ item.opis }</td> 
                                                <td className="gocenter">{ item.typ }</td> 
                                                <td className="gocenter">{ item.ost_aktywnosc }</td> 
                                            </tr>
                                            )
                                    } )
                                }

                            </tbody>
                </table>

            </div>

        </div>
    )

}


export default Reader;